
export const toast = {
  welcomeBack: 'Welcome back!',
  loginFailed: 'Login failed. Please check your credentials.',
  logoutSuccess: 'You have been signed out.',
  sessionExpired: 'Your session has expired. Please sign in again.',
  authenticationRequired: 'Authentication required',
  loginRequired: 'You must be logged in',
  loginRequiredForPlan: 'You must be logged in to create a plan',

  accountCreatedSuccess: 'Account created successfully! Check your email for the confirmation link',
  registrationFailed: 'Registration failed',

  otpVerificationSuccess: 'Device verified successfully. Welcome!',
  otpCodeSent: 'A new verification code has been sent to your email.',
  otpCodeSentFailed: 'Failed to send verification code. Please try again.',
  newDeviceDetected: 'New device detected. Please verify your identity.',

  passwordResetEmailSent: 'If an account exists with this email, you will receive reset instructions shortly.',
  passwordResetRequestFailed: 'Failed to send reset email. Please try again.',

  passwordResetSuccess: 'Password reset successfully. You can now sign in with your new password.',
  passwordResetFailed: 'Failed to reset password. Please request a new reset link.',

  passwordsDoNotMatch: 'New passwords do not match',
  passwordTooShort: 'Password must be at least 8 characters',
  passwordChangeSuccess: 'Password changed successfully!',
  passwordChangeFailed: 'Failed to change password',

  deviceAccessRevoked: 'Device access revoked',
  deviceRevokeFailed: 'Failed to revoke device',
  deviceRevokedSuccess: 'Device access revoked successfully.',
  deviceRevokedFailed: 'Failed to revoke device access. Please try again.',
  devicesLoadFailed: 'Failed to load devices',

  twoFactorEnabled: '2FA enabled',
  twoFactorDisabled: '2FA disabled',
  twoFactorToggleFailed: 'Failed to toggle 2FA',

  profileSetupComplete: 'Profile set up successfully!',
  profileSaveFailed: 'Failed to save profile',
  profileLoadFailed: 'Failed to load profile data',
  noChangesToSave: 'No changes to save',
  profileUpdateSuccess: 'Profile updated successfully!',
  profileUpdateFailed: 'Failed to update profile. Please try again.',
  avatarUploadSuccess: 'Profile photo updated.',
  avatarUploadFailed: 'Failed to upload photo. Please try again.',

  subscriptionCancelled: 'Subscription cancelled. Access until {{subscriptionEndDate}}',
  subscriptionCancelFailed: 'Failed to cancel subscription',
  paymentMethodUpdated: 'Payment method updated',
  paymentMethodUpdateFailed: 'Failed to update payment method',

  planGeneratedSuccess: 'Plan created successfully! 🎉',
  planGenerationFailed: 'Failed to create plan: {{errorMessage}}',
  planCreatedSuccess: 'Plan created successfully! 🎊',
  planCreateFailed: 'Failed to create plan',
  planUpdatedSuccess: 'Plan updated successfully.',
  planUpdateFailed: 'Failed to update plan. Please try again.',
  noPlanToDownload: 'No plan available to download',
  noPlanData: 'No plan data available. Please create a nutrition plan first.',
  noPlanPreview: 'No plan preview found. Please create a preview first.',
  mealCompletedSuccess: 'Meal marked as completed.',
  mealUncompletedSuccess: 'Meal marked as incomplete.',

  mealSwapped: '{{mealType}} on Day {{dayNumber}} swapped to {{newMealName}} ✨',
  mealsUpdatedForDay: 'All meals on Day {{dayNumber}} updated ✨',
  dietTypeUpdated: 'Diet type updated to {{newDietType}} ✨',
  calorieTargetAdjusted: 'Calorie target adjusted to {{newCalories}} kcal ✨',
  planModificationFailed: 'Failed to modify plan',

  pdfDownloadVipOnly: 'PDF download is a VIP feature. Please upgrade to access it.',
  generatingMealPlanPdf: 'Generating your nutrition plan PDF...',
  generatingDayPlanPdf: 'Generating daily meal plan PDF...',
  pdfDownloadSuccess: 'PDF downloaded successfully!',
  pdfGenerationFailed: 'Failed to generate PDF. Please try again.',

  recipeGenerationVipOnly: 'Recipe generation is a VIP feature',
  recipeGeneratedSuccess: 'Recipe generated successfully! 🎉',
  recipeGenerationFailed: 'Failed to generate recipe: {{errorMessage}}',
  recipeAddedToFavorites: 'Recipe added to favorites.',
  recipeRemovedFromFavorites: 'Recipe removed from favorites.',
  recipeAddedToShoppingList: 'Ingredients added to shopping list.',

  shoppingListUpdateFailed: 'Failed to update shopping list',
  loadShoppingListFailed: 'Failed to load shopping list',
  clearShoppingListFailed: 'Failed to clear shopping list',
  shoppingListCleared: 'Shopping list cleared.',
  shoppingListExported: 'Shopping list exported.',
  shoppingItemAdded: 'Item added to shopping list.',
  shoppingItemDeleted: 'Item removed from shopping list.',
  ingredientAddedToShoppingList: '{{food}} added to shopping list',
  ingredientQuantityUpdated: 'Quantity of {{food}} updated',
  ingredientAddFailed: 'Failed to add ingredient',
  ingredientsAddFailed: 'Failed to add ingredients',
  addIngredientsFailed: 'Failed to add ingredients',
  addItemFailed: 'Failed to add item',
  updateItemFailed: 'Failed to update item',
  removeItemFailed: 'Failed to remove item',
  removeItemsFailed: 'Failed to remove items',

  weightLogged: 'Weight logged!',
  weightLogFailed: 'Failed to log weight',
  weightEntryAdded: 'Weight entry added!',
  weightEntryUpdated: 'Weight entry updated!',
  weightEntrySaveFailed: 'Failed to save weight entry',
  weightEntryDeleted: 'Weight entry deleted',
  entryDeleteFailed: 'Failed to delete entry',
  weightAddedSuccess: 'Weight entry saved.',
  weightUpdatedSuccess: 'Weight entry updated.',
  weightDeletedSuccess: 'Weight entry deleted.',
  weightAddFailed: 'Failed to save weight. Please try again.',

  photoUploadSuccess: 'Photo uploaded!',
  photoUploadFailed: 'Failed to upload photo',
  photoDeleteFailed: 'Failed to delete photo',

  achievementUnlocked: '🎉 Achievement unlocked: {{title}}',

  productSettingsLoadFailed: 'Failed to load product settings',
  affiliateEnabledVipOnly: 'Affiliate system enabled – VIP users can now use Smart Shopping mode',
  affiliateDisabledSimpleList: 'Affiliate system disabled – All users switched to Simple List mode',

  sendMessageFailed: 'Failed to send message',

  savedSuccess: 'Changes saved successfully.',
  saveFailed: 'Failed to save changes. Please try again.',
  updateFailed: 'Update failed',
  copiedToClipboard: 'Copied to clipboard.',
  networkError: 'Network error. Please check your connection.',
  unknownError: 'An unexpected error occurred. Please try again.',
};